import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import Header from './header'
import './layout.css'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} />
        {children}
        <footer>
          <div className="Footer">
            <div>
              {/* <img
                className="footer-image"
                src={require('../images/gatsby-icon.png')}
              /> */}
              <p>© {new Date().getFullYear()}</p>
            </div>
            <a href="/data-protection">Data Protection</a>
            <a href="/imprint">Imprint</a>
          </div>
        </footer>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
